import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './_guards/auth.guard';

/* Components */
import { UserComponent } from './_components/user/user.component';
import { HomeComponent } from './_components/components_welcome/home/home.component';
import { LoginComponent } from './_components/login/login.component';
import { SignupComponent } from './_components/signup/signup.component';
import { UserVerificationComponent } from './_components/user-verification/user-verification.component';
import { SendemailComponent } from './_components/forgetPassword/sendemail/sendemail.component';
import { ResetpasswordComponent } from './_components/forgetPassword/resetpassword/resetpassword.component';
import { CombineComponent } from './_components/components_welcome/combine/combine.component';
import { GatewayComponent } from './_components/components_user/gateway/gateway.component';
import { MedicolegalComponent } from './_components/components_user/medicolegal/medicolegal.component';
import { ApicallComponent } from './_components/components_user/apicall/apicall.component';
import { WorkscomComponent } from './_components/components_user/workscom/workscom.component';
import { CasesimilarityComponent } from './_components/components_user/casesimilarity/casesimilarity.component';
import { ElasticsearchformComponent } from './_components/components_user/elasticsearchform/elasticsearchform.component';
import { ResultsComponent } from './_components/components_user/results/results.component';
import { ProfileComponent } from './_components/components_user/profile/profile.component';
import { QueryResultComponent } from './_components/components_user/query-result/query-result.component';
import { QueryAnalysisComponent } from './_components/components_user/query-analysis/query-analysis.component';
import { DashboardComponent } from './_components/components_user/dashboard/dashboard.component';
import { SubscribeResultComponent } from './_components/components_user/subscribe-result/subscribe-result.component';
import { SubscribeAnalysisComponent } from './_components/components_user/subscribe-analysis/subscribe-analysis.component';
import { StatenameComponent } from './_components/components_user/statename/statename.component';
import { DriverComponent } from './_components/components_user/driver/driver.component';
import { PreAuthorizationComponent } from './_components/components_user/pre-authorization/pre-authorization.component';
import { CompensationClaimComponent } from './_components/components_user/compensation-claim/compensation-claim.component';
import { DeniedCompensationComponent } from './_components/components_user/denied-compensation/denied-compensation.component';



const routes: Routes = [

    {
        path: 'welcome', children: [
            { path: '', component: HomeComponent },
            { path: 'gate', component: CombineComponent },
            { path: 'apicaller', component: ApicallComponent}
        ]
    },
    { path: 'login', component: LoginComponent },
    { path: 'verify/email/:emailId', component: UserVerificationComponent},
    { path: 'forgetpassword/sendemail', component: SendemailComponent},
    { path: 'forgetpassword/resetpassword/:emailId', component: ResetpasswordComponent },
    { path: 'signup', component: SignupComponent },
    { path: 'results/:searchId', component: ResultsComponent},
    { path: 'result/:searchId', component: SubscribeResultComponent},
    { path: 'subscribe/result/analysis', component: SubscribeAnalysisComponent},
    { path: 'user', component: UserComponent, canActivate: [AuthGuard], children: [
        { path: 'dashboard', component: DriverComponent},
        { path: 'Old_dashboard', component: GatewayComponent},
        { path: 'Worker_dashboard', component: DashboardComponent },
        { path: 'state', component: StatenameComponent },
        { path: 'medico_legal', component: MedicolegalComponent},
        { path: 'cases', component: MedicolegalComponent},
        { path: 'apicaller', component: ApicallComponent},
        { path: 'workers', component: WorkscomComponent},
        { path: 'case_similarity', component: CasesimilarityComponent},
        { path: 'query/result', component: QueryResultComponent},
        { path: 'query/result/analysis', component: QueryAnalysisComponent},
        { path: 'pre_auth/claim', component: PreAuthorizationComponent},
        { path: 'claim', component: CompensationClaimComponent},
        { path: 'denied/claim', component: DeniedCompensationComponent},
        { path: 'profile', component: ProfileComponent}
    ] },
    /* Redirect Routes GatewayComponent DashboardComponent*/
    { path: '', redirectTo: '/user/dashboard', pathMatch: 'full' },
    { path: '**', redirectTo: '/user/dashboard' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule { }

// { path: 'dashboard', component: ElasticsearchformComponent},


// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/app-routing.module.ts